export const clearPaymentMethods = (state) => {
	state.paymentMethods = null;
};

export const setPaymentMethods = (state, data) => {
	state.paymentMethods = data;
};

export const SET_SELECTED_METHOD = (state, data) => {
  state.selectedMethod = data;
}
